import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { IAccount } from '@account-users';

export enum DeliveryStatisticsActionTypes {
  Clear = '[Delivery Statistics] Clear',
  GetAccounts = '[Delivery Statistics] Get Accounts',
  GetAccountsSuccess = '[Delivery Statistics] Get Accounts Success',
  GetAccountsFail = '[Delivery Statistics] Get Accounts Fail',
  GetEmailStatistics = '[Delivery Statistics] Get Email Statistics',
  GetSmsStatistics = '[Delivery Statistics] Get Sms Statistics',
}

export class Clear implements Action {
  readonly type = DeliveryStatisticsActionTypes.Clear;
}

export class GetAccounts implements Action {
  readonly type = DeliveryStatisticsActionTypes.GetAccounts;
  constructor(public payload: { searchTerm?: string; loadAll?: boolean }) {}
}

export class GetAccountsSuccess implements Action {
  readonly type = DeliveryStatisticsActionTypes.GetAccountsSuccess;
  constructor(public payload: IAccount[]) {}
}

export class GetAccountsFail implements Action {
  readonly type = DeliveryStatisticsActionTypes.GetAccountsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetEmailStatistics implements Action {
  readonly type = DeliveryStatisticsActionTypes.GetEmailStatistics;
  constructor(public payload: { timeSpans: number[]; accountId: string }) {}
}

export class GetSmsStatistics implements Action {
  readonly type = DeliveryStatisticsActionTypes.GetSmsStatistics;
  constructor(public payload: { timeSpans: number[]; accountId: string }) {}
}

export type DeliveryStatisticsActions =
  | Clear
  | GetAccounts
  | GetAccountsSuccess
  | GetAccountsFail
  | GetEmailStatistics
  | GetSmsStatistics;
